<!--
 * @Description: 
 * @Date: 2021-02-05 23:41:15
-->
<template>
  <div>
    <div v-if="!livingStore.isDesktop" class="living-end">
      <img :src="livingStore.detail.videoPicUrl" />
      <div>
        <img src="@/static/img/notBegin.jpg" />
        <p>
          直播已经结束{{ livingStore.livingStatus === 4 ? '，转码中' : '' }}
        </p>
      </div>
    </div>
    <div v-else>
      <img
        style="width: 1228px; height: 675px"
        src="@/static/img/living/jiesua.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivingEnd',
  inject: ['livingStore'],
  created() {
    console.log(this.livingStore);
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
$--height: 5.63rem;
$--width: 10rem;
.living-end {
  position: relative;
  width: $--width;
  height: $--height;
  img {
    width: $--width;
    height: $--height;
  }
  > div {
    position: absolute;
    top: 0;
    left: 0;
    width: $--width;
    height: $--height;
    z-index: 10;
    background: #000;
    opacity: 0.8;
    text-align: center;
    img {
      width: 0.75rem;
      height: 0.75rem;
      margin: 2.12rem auto 0.21rem;
    }
    p {
      font-size: 0.43rem;
      color: rgba(239, 50, 76, 1);
      line-height: 0.43rem;
    }
  }
}
</style>
